import { z } from 'zod'
import { MENU_SUPPORT_EMAIL_MAX } from '~/services/api/contracts/bounds/MENU_SUPPORT_EMAIL_MAX'
import { MENU_SUPPORT_MESSAGE_MAX } from '~/services/api/contracts/bounds/MENU_SUPPORT_MESSAGE_MAX'
import { MENU_SUPPORT_NAME_MAX } from '~/services/api/contracts/bounds/MENU_SUPPORT_NAME_MAX'
import { MENU_SUPPORT_SUBJECT_MAX } from '~/services/api/contracts/bounds/MENU_SUPPORT_SUBJECT_MAX'
import { email } from '~/services/api/contracts/email'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { phone } from '~/services/api/contracts/phone'
import { MenuSupportRequestSchema, PreferredContactMethodSchema } from '~/services/api/generated'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

const schema = MenuSupportRequestSchema.extend({
  email: email(MENU_SUPPORT_EMAIL_MAX),
  message: z.string().min(1).max(MENU_SUPPORT_MESSAGE_MAX),
  name: z.string().min(1).max(MENU_SUPPORT_NAME_MAX),
  phone: phone.nullish(),
  subject: z.string().min(1).max(MENU_SUPPORT_SUBJECT_MAX)
}).strict()

const normalize = fieldNormalizer({
  trimmed: ['topic', 'name', 'email', 'subject', 'message'],
  blankToNull: ['phone', 'current_url'],
  enums: [{ field: 'preferred_contact_method', options: PreferredContactMethodSchema.options }]
})

export const MenuSupport = (_context: NoContext): z.ZodType<z.output<typeof schema>> =>
  z.preprocess(normalize, schema)
